import React, { useState, useEffect } from "react";
import CloseIcon from "@mui/icons-material/CloseRounded";
import { Button, Modal, Col, Row } from "react-bootstrap";
import _ from "lodash";
import ApiTransaction from "../../../../core/api/api.transaction";
import { useNavigate } from "react-router-dom";
import SplitNumber from "../../_Components/SplitNumber";

export const ViewModal = ({ showModalReportTransaction, setShowModalReportTransaction, selectedReport }) => {
  let navigate = useNavigate();
  let back = (e) => {
    e.stopPropagation();
    navigate(-1);
  };
  const [itam, setItem] = React.useState();
  const checkAndShowItem = (item) => {
    if (item) return item;
    else return "---";
  };
  const handleClose = () => {
    setShowModalReportTransaction(false);
  };
  useEffect(() => {
    (async () => {
      try {
        if (selectedReport > 0) {
          // دریافت اطلاعات کاربر جهت ویرایش
          let response = await ApiTransaction.getTransactionById(selectedReport);
          console.log("response", response);
          if (response.succeeded == true) {
            setItem(response.data);
            //setValue("roleList", response.data.roleList);
          }
        }
      } catch (error) {
        console.log("error :>> ", error);
      }
    })();
    return () => {};
  }, []);

  return (
    <div>
      {/* Start Modal */}
      {/* <Modal centered size='md' show={show} onHide={handleClose}> */}
      <Modal centered size="lg" onHide={handleClose} show={showModalReportTransaction}>
        <Modal.Header closeButton>
          <Modal.Title>اطلاعات تراکنش </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Col xs="12">
            {/* <div className="bg-light rounded shadow-2 py-2">
                            <div className="font-weight-bold text-center pb-2 mb-3">اطلاعات فردی</div>
                            <Col xs="auto">
                                <div className="d-flex align-items-center justify-content-between">
                                    <p>  نام و نام خانوادگی  : </p>
                                    <p> {checkAndShowItem(itam?.userFullName)}</p>
                                </div>
                            </Col>
                            <Col xs="auto">    <div className="d-flex align-items-center justify-content-between">
                                <p>       شماره همراه  : </p>
                                <p>       {checkAndShowItem(itam?.phoneNumber)}</p>
                            </div>
                            </Col>
                        </div> */}

            <div className="mb-3">
              {itam?.isDeleted ? (
                <p className="bg-light-danger text-danger p-3 fw-bold rounded-3"> تراکنش حذف شده است </p>
              ) : (
                <p className="bg-light-success text-success p-3 fw-bold rounded-3"> تراکنش فعال است </p>
              )}
            </div>
            <Row className="border-bottom mb-3 mt-5">
              <h4>اطلاعات تراکنش</h4>
              <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                <div className="fw-bold text-muted"> عنوان تراکنش </div>
                <div className="mt-2"> {checkAndShowItem(itam?.titleS)}</div>
              </Col>
              <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                <div className="fw-bold text-muted"> مبلغ </div>
                <div className="mt-2">
                  <SplitNumber number={checkAndShowItem(itam?.amount)} />
                </div>
              </Col>
              <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                <div className="fw-bold text-muted"> نوع تراکنش </div>
                <div className="mt-2"> {checkAndShowItem(itam?.typeS)}</div>
              </Col>
              <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                <div className="fw-bold text-muted"> تاریخ انجام </div>
                <div className="mt-2"> {checkAndShowItem(itam?.completionDate)}</div>
              </Col>
              <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                <div className="fw-bold text-muted"> زمان انجام </div>
                <div className="mt-2"> {checkAndShowItem(itam?.completionTime)}</div>
              </Col>
              <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                <div className="fw-bold text-muted"> مقصد </div>
                <div className="mt-2"> {checkAndShowItem(itam?.targetTransactionTitleS)}</div>
              </Col>
              {itam?.agency && (
                <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                  <div className="fw-bold text-muted"> آژانس </div>
                  <div className="mt-2"> {checkAndShowItem(itam?.agency?.name)}</div>
                </Col>
              )}
              {itam?.supplier && (
                <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                  <div className="fw-bold text-muted"> تامین کننده </div>
                  <div className="mt-2"> {checkAndShowItem(itam?.supplier?.companyName)}</div>
                </Col>
              )}
              {itam?.account && (
                <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                  <div className="fw-bold text-muted"> حساب </div>
                  <div className="mt-2"> {checkAndShowItem(itam?.account?.accountNumber)}</div>
                </Col>
              )}
              {itam?.systemAccount && (
                <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                  <div className="fw-bold text-muted"> حساب سیستم </div>
                  <div className="mt-2"> {checkAndShowItem(itam?.systemAccount?.accountNumber)}</div>
                </Col>
              )}

              {itam?.description && (
                <Col xs="12" sm="4" lg="3" className="mt-2 mb-5">
                  <div className="fw-bold text-muted">توضیحات </div>
                  <div className="mt-2">{itam?.description}</div>
                </Col>
              )}
            </Row>

            {itam?.userPayment && (
              <Row className="border-bottom mb-3 mt-5">
                <h4>اطلاعات پرداخت</h4>

                <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                  <div className="fw-bold text-muted"> شماره پرداخت </div>
                  <div className="mt-2"> {checkAndShowItem(itam?.userPayment?.id)}</div>
                </Col>
                {itam.riallBalance !== itam.userPayment.rialAmount && (
                  <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                    <div className="fw-bold text-muted"> مبلغ </div>
                    <div className="mt-2"> {checkAndShowItem(itam?.userPayment?.rialAmount.toLocaleString())}</div>
                  </Col>
                )}
                {itam.completionDate !== itam.userPayment.paymentDate && (
                  <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                    <div className="fw-bold text-muted"> تاریخ انجام </div>
                    <div className="mt-2"> {checkAndShowItem(itam?.userPayment?.paymentDate)}</div>
                  </Col>
                )}
                {itam.completionTime !== itam.userPayment.paymentTime && (
                  <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                    <div className="fw-bold text-muted"> زمان انجام </div>
                    <div className="mt-2"> {checkAndShowItem(itam?.userPayment?.paymentTime)}</div>
                  </Col>
                )}
                <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                  <div className="fw-bold text-muted"> شماره کارت پرداخت </div>
                  <div className="mt-2"> {checkAndShowItem(itam?.userPayment?.cardNumberPayment)}</div>
                </Col>
                <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                  <div className="fw-bold text-muted"> شماره مرجع (referenceId) </div>
                  <div className="mt-2"> {checkAndShowItem(itam?.userPayment?.referenceId)}</div>
                </Col>
                <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                  <div className="fw-bold text-muted"> شماره توکن </div>
                  <div className="mt-2"> {checkAndShowItem(itam?.userPayment?.tokenNumber)}</div>
                </Col>
                <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                  <div className="fw-bold text-muted"> شماره ای پی </div>
                  <div className="mt-2"> {checkAndShowItem(itam?.userPayment?.userIp)}</div>
                </Col>
                {itam.description !== itam.userPayment.description && (
                  <Col xs="12" sm="4" lg="3" className="mt-2 mb-5">
                    <div className="fw-bold text-muted"> توضیحات </div>
                    <div className="mt-2">{itam?.userPayment?.description}</div>
                  </Col>
                )}
              </Row>
            )}
            {itam?.basket && (
              <Row className="border-bottom mb-3 mt-5">
                <h4>اطلاعات سبد خرید</h4>

                <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                  <div className="fw-bold text-muted"> شماره سبد </div>
                  <div className="mt-2"> {checkAndShowItem(itam?.basket?.id)}</div>
                </Col>
                <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                  <div className="fw-bold text-muted"> مبلغ اصلی </div>
                  <div className="mt-2"> {checkAndShowItem(itam?.basket?.originalPrice.toLocaleString())}</div>
                </Col>
                <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                  <div className="fw-bold text-muted"> مبلغ نهایی </div>
                  <div className="mt-2"> {checkAndShowItem(itam?.basket?.price.toLocaleString())}</div>
                </Col>
                {/* <Col xs="auto">
                                    وضعیت سبد  : {itam?.basket?.status}
                                </Col> */}
              </Row>
            )}
            {itam?.userWithdrawal && (
              <>
                <Row className="border-bottom mb-3 mt-5">
                  <h4>اطلاعات درخواست برداشت وجه</h4>
                  <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                    <div className="fw-bold text-muted"> شماره درخواست </div>
                    <div className="mt-2"> {checkAndShowItem(itam?.userWithdrawal?.id)}</div>
                  </Col>
                  {itam.riallBalance !== itam.userWithdrawal.rialAmount && (
                    <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                      <div className="fw-bold text-muted"> مبلغ </div>
                      <div className="mt-2"> {checkAndShowItem(itam?.userWithdrawal?.rialAmount.toLocaleString())}</div>
                    </Col>
                  )}
                  {itam.completionDate !== itam.userWithdrawal.paymentDate && (
                    <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                      <div className="fw-bold text-muted"> تاریخ انجام </div>
                      <div className="mt-2">{checkAndShowItem(itam?.userWithdrawal?.paymentDate)}</div>
                    </Col>
                  )}
                  {itam.completionTime !== itam.userWithdrawal.paymentTime && (
                    <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                      <div className="fw-bold text-muted"> زمان انجام </div>
                      <div className="mt-2"> {checkAndShowItem(itam?.userWithdrawal?.paymentTime)}</div>
                    </Col>
                  )}

                  {/* <Col xs="auto">
                                    وضعیت درخواست  : {itam?.userWithdrawal?.status}
                                </Col> */}
                </Row>
                {itam.userWithdrawal.destinationAccount && (
                  <Row className="border-bottom mb-3 mt-5">
                    <h4> اطلاعات حساب مقصد </h4>

                    <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                      <div className="fw-bold text-muted"> نام بانک </div>
                      <div className="mt-2"> {checkAndShowItem(itam.userWithdrawal.destinationAccount.bank)}</div>
                    </Col>
                    <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                      <div className="fw-bold text-muted"> نام صاحب حساب </div>
                      <div className="mt-2">
                        {checkAndShowItem(itam.userWithdrawal.destinationAccount.accountOwnerName)}
                      </div>
                    </Col>
                    <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                      <div className="mt-2"> شماره حساب </div>
                      <div className="mt-2">
                        {checkAndShowItem(itam.userWithdrawal.destinationAccount.accountNumber)}
                      </div>
                    </Col>
                    <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                      <div className="fw-bold text-muted"> نام صاحب کارت </div>
                      <div className="mt-2">
                        {checkAndShowItem(itam.userWithdrawal.destinationAccount.cardOwnerName)}
                      </div>
                    </Col>
                    <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                      <div className="fw-bold text-muted"> شماره کارت </div>
                      <div className="mt-2"> {checkAndShowItem(itam.userWithdrawal.destinationAccount.cardNumber)}</div>
                    </Col>
                    <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                      <div className="fw-bold text-muted"> شماره شبا </div>
                      <div className="mt-2">{checkAndShowItem(itam.userWithdrawal.destinationAccount.shebaNumber)}</div>
                    </Col>
                  </Row>
                )}
              </>
            )}
            {itam?.basketLogs && itam.basketLogs?.length > 0 && (
              <Row className="border-bottom mb-3 mt-5">
                <h4> لیست تغییرات </h4>
                <Row>
                  <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                    <div className="fw-bold text-muted"> شماره </div>
                  </Col>
                  <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                    <div className="fw-bold text-muted"> مقدار </div>
                  </Col>
                  <Col xs="12" sm="4" lg className="mt-2 mb-5">
                    <div className="fw-bold text-muted"> توضیحات </div>
                  </Col>
                </Row>
                {itam?.basketLogs?.map((item2, index) => (
                  <Row key={index}>
                    <Col xs="2" sm="4" lg="3" className="mb-5">
                      <div> {item2.id} </div>
                    </Col>
                    <Col xs="2" sm="4" lg="3" className="mb-5">
                      <div> {item2.value} </div>
                    </Col>
                    <Col xs="2" sm="4" lg="3" className="mb-5">
                      <div> {item2.description} </div>
                    </Col>
                  </Row>
                ))}
              </Row>
            )}
          </Col>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={handleClose}>
            <CloseIcon /> بستن
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};
